import FocusTrap from 'focus-trap-react';
import React, { FC } from 'react';

import { FocusTrapWrapperProps } from './models';

export const FocusTrapWrapper: FC<FocusTrapWrapperProps> = ({
  isOpen,
  isJS,
  isMobileView,
  children,
}) => {
  const Wrapper = isOpen && isJS && isMobileView ? FocusTrap : React.Fragment;

  return <Wrapper>{children}</Wrapper>;
};
